module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/bl-669bbb820754f1cc0ce4bf010c056e23.svg";